<div class="stick-top">
  <mat-toolbar>
    <mat-icon>terminal</mat-icon> Managed Commands
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/managed/0">
      <mat-icon>add</mat-icon>
      Create a new Managed Command
    </button>
    <span class="fill-space"></span>
    <button mat-raised-button class="primary" type="button" (click)="reload()">Refresh</button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="isAdmin" class="align-top">
        <div class="vbox" style="min-width: 130px">
          Company
          <micro-company-select *ngIf=" !this.auth.companyIdFilter" [(companyId)]="filter.companyId"></micro-company-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Name
          <input [(ngModel)]="filter.name">
        </div>
      </th>
      <th>
        <div class="vbox">
          Code
          <input [(ngModel)]="filter.code">
        </div>
      </th>
      <th>
        <div class="vbox">
          Command Type
          <micro-serviceType-select [(serviceType)]="filter.commandType"></micro-serviceType-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Enabled
          <micro-yesNo-select [(yesNo)]="filter.enabled"
                              yesOption="ENABLED"
                              noOption="DISABLED">
          </micro-yesNo-select>
        </div>
      </th>
      <th>Create Date/Time</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="isAdmin"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td><a routerLink="/managed/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.code}}</td>
      <td>{{element.commandType}}</td>
      <td [ngClass]="element.enabled ? '' : 'CRITICAL'">{{element.enabled ? 'ENABLED' : 'DISABLED'}}</td>
      <td>{{element.createdDate | dateTime}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
